import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetPortal,
  SheetOverlay,
} from '@design-system/Sheet';
import { Skeleton } from '@design-system/Skeleton';

interface TrackingSampleSkeletonProps {
  isOpen: boolean;
  onClose: () => void;
}
  
export const TrackingSampleSkeleton = ({ isOpen, onClose }: TrackingSampleSkeletonProps) => (
  <Sheet open={isOpen} onOpenChange={onClose}>
    <SheetPortal>
      <SheetOverlay />
      <SheetContent side="right" className="w-full pr-0 pl-4" variant="glass">
        <SheetHeader>
          <div className="space-y-4">
            <Skeleton className="h-8 w-48" />
            <Skeleton className="h-4 w-32" />
            {[...Array(8)].map((_, i) => (
              <Skeleton key={i} className="h-16 w-full mt-4" />
            ))}
          </div>
        </SheetHeader>
      </SheetContent>
    </SheetPortal>
  </Sheet>
);